export class NumericRange {
    Min;
    Max;
    constructor(Min, Max) {
        this.Min = Min;
        this.Max = Max;
        if (Min > Max) {
            throw new Error("Min cannot be greater than max");
        }
    }
    GetResult(useRandom) {
        if (useRandom) {
            return (this.Max - this.Min) * Math.random() + this.Min;
        }
        else {
            return (this.Max + this.Min) / 2;
        }
    }
}
//# sourceMappingURL=range.js.map